import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  FormHelperText,
  Grid,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import PhoneInput from "react-phone-input-2";
import { useLazyGetSpecificAgentByIdQuery } from "../../services/agents";
import { UploadMedia, Uploadpdf } from "../../utils/uploadMedia";
import { errorToast, successToast, warnToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import {
  useAddUserApiMutation,
  useEditUserMutation,
  useLazyGetAllTypeOfCompaniesQuery,
} from "../../services/users";
import Loader from "../../helpers/constants/Loader";
import { Autocomplete as MUIAutocomplete } from "@mui/material";
import { isString } from "../../utils/validation";
import { AGENT_EMIRATE, DOCUMENT_TYPE, ROLE } from "../../constants/enums";
import { Nationality } from "../../constants/Nationality";
import moment from "moment";




const TeachingDetails = () => {
  const [dialCode, setPhoneCode] = useState("+971");
  const [error, setError] = useState(false);
  const nationalityData = Nationality;
  const [profile_picture, setProfilePicture] = useState("");
  const [ByIdDetails, setByIdDetails] = useState<any>(null);
  const navigate = useNavigate();
  const [editUSERbyId] = useEditUserMutation();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [fetchApi] = useLazyGetSpecificAgentByIdQuery();
  const [addUser] = useAddUserApiMutation();
  const [companyListingApi] = useLazyGetAllTypeOfCompaniesQuery();
  const [companyListing, setCompanyListing] = useState<any>([]);
  const [companyId, setCompanyId] = useState<string>("");
 
  

  const fetchCompanyListing = async () => {
    try {
      const res = await companyListingApi({ role: ROLE.AGENCY }).unwrap();
      if (res?.statusCode === 200) {
        setCompanyListing(res?.data);

      }
    } catch (error: any) {
      //console.log(error?.data?.message);
    }
  };


  

  const fetchDataById = async (id: any) => {
    setIsLoading(true)
    try {
      const response = await fetchApi({ userId: id }).unwrap();
      if (response.statusCode === 200) {
        setByIdDetails(response?.data);
        setPhoneCode(response?.data?.dialCode || "");
        setCompanyId(response?.data?.parentAgentId || "")
        //console.log('response?.data?.parentAgentId: ', response?.data);
      }
      setIsLoading(false)
    } catch (error: any) {
      setIsLoading(false)
      console.error(error);
      errorToast(error?.message || error?.data?.message);
    }
  };


  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");

        return;
      }

      const res = await UploadMedia(file);
      if (res?.statusCode === 200) {
        const imageUrl = res?.data[0]?.location;
        formik.setFieldValue("profile_picture", imageUrl);
        setProfilePicture(imageUrl);
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      errorToast("Error uploading image. Please try again.");
    }
  };


  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      address: "",
      companyName: "",
      dialCode: dialCode,
      profile_picture: profile_picture,
      latitude: 0,
      longitude: 0,
      parentAgentId: "",
      companyLocation: "",
      positionInTheCompany: "",
      experience: "",
      languages: [],
      nationality: "",
      linkedIn: "",
      agentEmirate: "",



    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          "Enter a valid email address"
        )
        .matches(
          /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/, // Regex to disallow emojis
          "Emojis are not allowed in the email address"
        ),
      phone: Yup.string().required("Phone number is required"),
      // address: Yup.string().required("Address is required"),
      companyName: Yup.string().required("Company name is required"),
      // companyLocation: Yup.string().required("Company location is required"),
      // positionInTheCompany: Yup.string().required("This Field is required"),
      // experience: Yup.string().required("This Field is required"),
      // nationality: Yup.string().required("This Field is required"),
      // linkedIn: Yup.string().required("This Field is required"),
      // agentEmirate: Yup.string().required("This Field is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;



      let body: any = {
        name: values.name || "",
        email: values.email || "",
        phoneNo: values.phone || "",
        image: values?.profile_picture || "",
        dialCode: dialCode,
        parentAgentId: companyId || "",
        companyName: values.companyName || "",
        latitude: values?.latitude || 0,
        longitude: values?.longitude || 0,
        positionInTheCompany: values?.positionInTheCompany || "",
        experience: values?.experience || "",
        languages: values?.languages || "",
        nationality: values?.nationality || "",
        linkedIn: values?.linkedIn || "",
        // documents: [
        //   {
        //     documentType: DOCUMENT_TYPE.EMIRATES_ID,
        //     documentNumber: documents.documentNumber_17,
        //     frontImage: documents.frontImage_17,
        //     backImage: documents.backImage_17,
        //     expiryDate: documents.expiryDate_17 ? moment(documents.expiryDate_17).utc()
        //       .format('YYYY-MM-DDTHH:mm:ss[Z]') : ""
        //   },
        //   ...(formik.values.agentEmirate == String(AGENT_EMIRATE.DUBAI_BASED)
        //     ? [
        //       {
        //         documentNumber: documents.BRN,
        //         frontImage: documents.brn_certificate,
        //         expiryDate: documents.brn_expiryDate ? moment(documents.brn_expiryDate).utc()
        //           .format('YYYY-MM-DDTHH:mm:ss[Z]') : ""
        //       },
        //     ]
        //     : []),
        //   ...(formik.values.agentEmirate == String(AGENT_EMIRATE.ABU_DHABI)
        //     ? [
        //       {
        //         documentType: DOCUMENT_TYPE.ADREC_OR_DARI_CARD,
        //         documentNumber: documents.documentNumber_19,
        //         frontImage: documents.frontImage_19,
        //       },
        //     ]
        //     : []),

        //   ...(formik.values.agentEmirate == String(AGENT_EMIRATE.OTHERS)
        //     ? [
        //       {
        //         documentType: DOCUMENT_TYPE.LABOUR_OR_EMPLOYMENT_VISA,
        //         documentNumber: documents.documentNumber_20,
        //         frontImage: documents.frontImage_20,
        //       },
        //     ]
        //     : []),
        // ]
      };
      // if (values?.agentEmirate) {
      //   body.agentEmirate = values?.agentEmirate
      // }

      if (!id) {
        body = { ...body, role: ROLE.AGENT };
      }
      console.log(body, "body");

      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      if (id) {
        try {
          const response = await editUSERbyId({
            id,
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Agent updated successfully");
            navigate("/manage-agents");
          }
        } catch (error: any) {
          errorToast(error?.data?.message);
        } finally {
          setSubmitting(false);
        }
      } else {
        try {
          const response = await addUser({ body: encryptedBody }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Agent Added successfully");
            navigate("/manage-agents");
            navigate(`/manage-agents/add/${response?.data?._id}/${1}`);
          }
        } catch (error: any) {
          errorToast(error?.data?.message);
        } finally {
          setSubmitting(false);
        }
      }
    },
  });
  console.log(formik.values.agentEmirate, "formik.values.agentEmirate");


  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  useEffect(() => {
    fetchCompanyListing();
  }, []);

  useEffect(() => {
    if (ByIdDetails) {
      formik.setValues({
        name: ByIdDetails?.name || "",
        email: ByIdDetails?.email || "",
        phone: ByIdDetails?.phoneNo || "",
        profile_picture: ByIdDetails?.image || "",
        dialCode: ByIdDetails?.dialCode || "",
        companyName: ByIdDetails?.companyName || "",
        address: ByIdDetails?.address || "",
        latitude: ByIdDetails?.latitude || 0,
        longitude: ByIdDetails?.longitude || 0,
        parentAgentId: ByIdDetails?.parentAgentId || "",
        companyLocation: ByIdDetails?.companyLocation || "",
        positionInTheCompany: ByIdDetails?.positionInTheCompany || "",
        experience: ByIdDetails?.experience || "",
        languages: ByIdDetails?.languages || "",
        nationality: ByIdDetails?.nationality || "",
        linkedIn: ByIdDetails?.linkedIn || "",
        agentEmirate: ByIdDetails?.agentEmirate || "",

      });
      setCompanyId(ByIdDetails?.parentAgentId)
    }
  }, [ByIdDetails]);

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  return (
    <div className="main_loyout">
      <Loader isLoad={isLoading} />
      {/* <div className="dashboard">
        <h1 className="mn_hdng">{id ? "Edit Agent" : "Add Agent"}</h1>
        <Button
          className="btn btn_primary"
          onClick={() => {
            navigate("/manage-agents", { replace: true });
          }}
        >
          Back
        </Button>
      </div> */}
      <Card className="cards">
        <form onSubmit={formik.handleSubmit}>
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2}>

              <Grid item xs={12}>
                <Typography className="custom_label">Image</Typography>
                {formik.values.profile_picture ? (
                  <div className="upload_image_preview">
                    <CardMedia
                      component="img"
                      image={formik.values.profile_picture}
                      alt="photo"
                    />
                    <CancelIcon
                      onClick={(e) => {
                        e.preventDefault();
                        setProfilePicture("");
                        formik.setFieldValue("profile_picture", "");
                      }}
                    />
                  </div>
                ) : (
                  <Box className="upload_image">
                    <label htmlFor="icon-button-file">
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "image/png,image/jpeg",
                        }}
                        onChange={handleImageUpload}
                      />
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/user_placeholder.png" alt="" />
                        <CameraAltIcon />
                      </Button>
                    </label>
                  </Box>
                )}
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Full Name</Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="name"
                  variant="outlined"
                  fullWidth
                  placeholder="Full Name"
                  onChange={(val) => {
                    if (
                      val.target.value === " " ||
                      val.target.value === "."
                    ) {
                    } else if (isString(val.target.value)) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Email</Typography>

                <TextField
                  hiddenLabel
                  className="text_field"
                  type="text"
                  name="email"
                  variant="outlined"
                  fullWidth
                  placeholder="Email"
                  onChange={(val) => {
                    if (
                      val.target.value === " "

                    ) {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <Typography className="custom_label">Phone Number</Typography>
                <PhoneInput
                  value={dialCode + formik.values.phone}
                  country={"ae"}
                  placeholder="0 (000) 000-000"
                  enableSearch={true}
                  inputStyle={{ width: "100%" }}
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.phone && formik.errors.phone ? (
                  <h6 className="err_msg">
                    {formik.touched.phone && formik.errors.phone.toString()}
                  </h6>
                ) : (
                  ""
                )}
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Position in the Company</Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="positionInTheCompany"
                  variant="outlined"
                  fullWidth
                  placeholder="Position in the company"
                  onChange={(val) => {
                    if (
                      val.target.value === " " ||
                      val.target.value === "."
                    ) {
                    } else if (isString(val.target.value)) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.positionInTheCompany}
                  error={formik.touched.positionInTheCompany && Boolean(formik.errors.positionInTheCompany)}
                  helperText={formik.touched.positionInTheCompany && formik.errors.positionInTheCompany}
                />
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Experience</Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="experience"
                  variant="outlined"
                  fullWidth
                  placeholder="Experience"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.experience}
                  error={formik.touched.experience && Boolean(formik.errors.experience)}
                  helperText={formik.touched.experience && formik.errors.experience}
                />
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Languages Known</Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="languages"
                  variant="outlined"
                  fullWidth
                  placeholder="languages known (comma separated)"
                  onChange={(e) => {
                    const value = e.target.value.split(',').map((language) => language.trim());
                    formik.setFieldValue("languages", value);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.languages}
                  error={formik.touched.languages && Boolean(formik.errors.languages)}
                  helperText={formik.touched.languages && formik.errors.languages}
                />
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Nationality</Typography>


                <Select
                  labelId="category-label"
                  value={formik.values.nationality || ""}
                  id="category-select"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250, // Adjust height
                        width: 250,     // Adjust width
                      },
                    },
                  }}
                  name="nationality"
                  fullWidth
                  displayEmpty
                  onChange={(e) => {

                    formik.setFieldValue("nationality", e.target.value)
                  }}
                >
                  <MenuItem value={''} disabled>
                    Select
                  </MenuItem>

                  {nationalityData?.map((item, index) => (
                    <MenuItem key={item} value={item}>
                      {item || ''}
                    </MenuItem>
                  ))}

                </Select>
                {formik.touched.nationality && formik.errors.nationality && (
                  <FormHelperText sx={{ color: "red" }}>{String(formik.errors.nationality)}</FormHelperText>
                )}
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Linkedin</Typography>

                <TextField
                  hiddenLabel
                  type="text"
                  className="text_field"
                  name="linkedIn"
                  variant="outlined"
                  fullWidth
                  placeholder="LinkedIn"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.linkedIn}
                  error={formik.touched.linkedIn && Boolean(formik.errors.linkedIn)}
                  helperText={formik.touched.linkedIn && formik.errors.linkedIn}
                />
              </Grid>
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <div className="control_group w_50">
                  <Typography className="custom_label">Agent Emirate</Typography >
                  <Select
                    labelId="category-label"
                    value={formik.values.agentEmirate || ""}
                    id="category-select"
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // Adjust height
                          width: 250,     // Adjust width
                        },
                      },
                    }}
                    name="agentEmirate"
                    fullWidth
                    displayEmpty
                    onChange={(e) => {
                      formik.setFieldValue('city', '');
                      // handleValueChange({ key: 'agentEmirate', value: e.target.value });
                      formik.setFieldValue("agentEmirate", e.target.value)
                    }}
                  >
                    <MenuItem value={''} disabled>
                      Select
                    </MenuItem>

                    <MenuItem value={AGENT_EMIRATE.DUBAI_BASED}>
                      Dubai Based
                    </MenuItem>
                    <MenuItem value={AGENT_EMIRATE.ABU_DHABI}>
                      Abu Dhabi Based
                    </MenuItem>
                    <MenuItem value={AGENT_EMIRATE.OTHERS}>
                      Others
                    </MenuItem>

                  </Select>
                  {formik.touched.agentEmirate && formik.errors.agentEmirate && (
                    <FormHelperText sx={{ color: "red" }}>{String(formik.errors.agentEmirate)}</FormHelperText>
                  )}
                </div>
              </Grid> */}


              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Typography className="custom_label">Company Name</Typography>
                <MUIAutocomplete
                  options={companyListing || []}
                  getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Company"
                      variant="outlined"
                      fullWidth
                      error={
                        formik.touched?.companyName &&
                        Boolean(formik.errors?.companyName)
                      }
                      onBlur={formik.handleBlur}
                      name="companyName"
                    />
                  )}
                  value={
                    companyListing?.find(
                      (item: any) =>
                        item?._id === companyId
                    ) || null
                  }
                  disabled={id ? true : false}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "companyName",
                      newValue?.companyName || ""
                    );
                    setCompanyId(newValue?._id || "");
                  }}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option?._id === value?._id
                  }
                />
                {formik.touched.companyName &&
                  formik.errors.companyName && (
                    <FormHelperText sx={{ color: "red" }}>
                      {String(formik.errors.companyName)}
                    </FormHelperText>
                  )}
              </Grid>
            </Grid>

           



            <div className="form_btn">
              <Button
                size="large"
                type="submit"
                className="btn btn_primary"
                onClick={() => setError(true)}
              >
                Submit
              </Button>
            </div>
          </CardContent>
        </form>
      </Card>
    </div>
  );
};

export default TeachingDetails;
